<template>
    <div class="shipping_method">
        <div v-if="shipping_code !== undefined && show_shipping">
            <h3>{{ gettext('Versand') }}</h3>
            <div
                v-for="shipping_method in shipping_methods"
                :key="shipping_method.value"
            >
                <input
                    type="radio"
                    :checked="shipping_method.value === shipping_code"
                    :id="shipping_method.value"
                    :value="shipping_method.value"
                    :disabled="!shipping_method.is_available"
                    @change="set_basket_shipping_method"
                />
                &nbsp;
                <label
                    :for="shipping_method.value"
                    :class="shipping_method.is_available ? '' : 'text-muted'"
                >
                    {{ shipping_method.display_name }}
                </label>
                <!--only show the date picker for the current shipping method if changing the date is supported -->
                <div
                    class="inline-block"
                    v-if="
                        basket.lines.length > 0 &&
                        shipping_method.value === shipping_code &&
                        shipping_method.can_pick_date &&
                        basket.can_change_delivery_date
                    "
                >
                    <div class="inline-picker">
                        (<date-picker
                            :enabled="true"
                            :min_date="basket_min_delivery_date"
                            :set_date="set_basket_date"
                            :date="basket_delivery_date"
                            :button_text="gettext('Datum wählen')"
                        ></date-picker
                        >)
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from './delivery_date.vue'
import dateFormat from 'dateformat'
import { parse_date } from '../utils'
export default {
    props: ['basket'],
    data() {
        return {}
    },
    components: {
        'date-picker': DatePicker,
    },
    methods: {
        set_basket_shipping_method(event) {
            const shipping_code = event.target.value
            const data = { shipping_code }
            this.$store.dispatch('update_basket', { data })
        },
        set_basket_date(date) {
            const requested_delivery_date = dateFormat(date, 'yyyy-mm-dd')
            const data = { requested_delivery_date }
            this.$store.dispatch('update_basket', { data })
        },
    },
    computed: {
        shipping_code() {
            return this.basket.shipping_code
        },
        shipping_method() {
            return this.shipping_methods.find(
                (method) => method.value === this.shipping_code
            )
        },
        shipping_methods() {
            return this.basket.shipping_method_choices
        },
        basket_min_delivery_date() {
            const line = this.$store.getters.basket_regular_lines.reduce(
                function (prev, curr) {
                    return prev.earliest_delivery_date <
                        curr.earliest_delivery_date
                        ? prev
                        : curr
                }
            )
            return parse_date(line.earliest_delivery_date)
        },
        basket_delivery_date() {
            return this.basket_min_delivery_date
        },
        show_shipping() {
            return this.$store.getters.basket_regular_lines.length > 0
        },
    },
}
</script>

<style>
.inline-picker {
    display: inline-block;
    margin-left: 1ch;
}
.inline-picker .input-group .form-control {
    margin-bottom: -10px;
}
</style>
